import React, { createContext, useState } from 'react'
import { get, post } from 'utils/apiClient'
import { v4 as uuidv4 } from 'uuid';

const MasterLocationContext = createContext()

function Provider({ children }) {
    const api_url = process.env.REACT_APP_API_URL

    const [apptSysTypes, setApptSysTypes] = useState([])
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [msg, setMsg] = useState()
    const [bulkResponse, setBulkResponse] = useState()

    const fetchAllApptSys = async (search_term) => {
        setLoading(true)
        let response = null
        try {
            const url = search_term ? 'appt-sys/all?search_term=' + search_term : 'appt-sys/all'
            response = await get(url)
            console.log(response)
            setApptSysTypes(response)
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    const saveBulk = async (obj) => {
        // setLoading(true)
        // let response = null
        // try {
        //     const url = 'location-management/master-locations/bulk'
        //     response = await post(url, obj)
        //     setBulkResponse(response)
        //     setLoading(false)
        //     setSuccess(true)
        // } catch (error) {
        //     setError(true)
        //     setMsg(error.message)
        //     console.error(error)
        //     setLoading(false)
        // }
        setLoading(true)
                let response = null
                let totalSuccess = 0;
                let totalError = 0;
                let batchMessages = [];
                let downloadUrl
                try {
                    const url = 'location-management/master-locations/bulk'
        
                    const total = obj.data.length;
                        const results = [];
                        const jobId = uuidv4(); 
                        for (let i = 0; i < total; i += 50) {
                            const batch = obj.data.slice(i, i + 50);
                            try {
                            const response =await post(url, {'data': batch, 'job_id': jobId})
                            console.log(response)
                            const { message, successCount, errorCount } = response;
                            downloadUrl = response.downloadUrl
                            totalSuccess += successCount || 0;
                            totalError += errorCount || 0;
                            
                           
                            } catch (error) {
                                console.error(`Batch ${i / 50 + 1} failed`, error);
                            }
                        }
        
                    const finalResponse = {
                        message: `All batches processed.`,
                        successCount: totalSuccess,
                        errorCount: totalError,
                        downloadUrl: downloadUrl
                    };
            
                    console.log("Final Response:", finalResponse);
            
                    setBulkResponse(finalResponse);
                    setLoading(false)
                    setSuccess(true)
                } catch (error) {
                    console.error(error)
                    setLoading(false)
                    setError(true)
                }

    }

    const valueToShare = {
        loading,
        success,
        setSuccess,
        apptSysTypes,
        fetchAllApptSys,
        error,
        setError,
        msg,
        saveBulk,
        bulkResponse
    }

    return (
        <MasterLocationContext.Provider value={valueToShare}>{children}</MasterLocationContext.Provider>
    )

}


export { Provider }
export default MasterLocationContext